export const CUSTOMER_TYPES = {
  BASIC: 'Basis',
  NORMAL: 'Op maat',
  SANDWICH: 'Broodjes',
}
